import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ '../components/Login.vue')
    },
    {
      path: '/product/:theme',
      name: 'themedLogin',
      component: () => import(/* webpackChunkName: "about" */ '../components/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "about" */ '../components/Registration.vue')
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: () => import(/* webpackChunkName: "about" */ '../components/ForgotPassword.vue')
    },
    { path: '*', redirect: '/' }
  ]
})
